import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { from, map, Observable, switchMap } from 'rxjs';
import { Attachment } from '@panaya/ai-chat/shared';
import { PickerAttachmentSource } from '@panaya/ai-chat/ui';
import { injectPDialog } from '@frontend-site/ui/components';
import { ProjectStore, RdxContextType } from '@frontend-site/shared/core';
import { RequirementPickResult } from './model/requirement-pick-result.model';
import { toRequirementAttachments } from './requirement-attachments.mapper';

/** The chat's "+" menu item "Link Requirement": the requirement search dialog the test tree uses, one requirement. */
export const REQUIREMENT_ATTACHMENT_SOURCE: PickerAttachmentSource = {
    kind: 'picker',
    resourceType: 'requirement',
    labelKey: 'seemore.attach.link_requirement',
    icon: 'box',
    group: 'entities',
    pick: openRequirementPicker
};

function openRequirementPicker(): Observable<Attachment[]> {
    const dialog = injectPDialog();

    const projectStore = inject(ProjectStore);

    const translate = inject(TranslateService);

    // Loaded on first use, so the dialog and its grid stay out of the app's initial bundle.
    const dialogModule = import(
        '@modules/defect-details/dialogs/requirement-search-linked-entities-dialog/requirement-search-linked-entities-dialog'
    );

    return from(dialogModule).pipe(
        switchMap(({ RequirementSearchLinkedEntitiesDialog }) =>
            dialog
                .open<unknown, unknown, RequirementPickResult | undefined>(RequirementSearchLinkedEntitiesDialog, {
                    panelClass: 'p-dialog-large',
                    data: {
                        projectId: projectStore.projectId,
                        companyId: projectStore.projectDetails?.companyId,
                        linkedEntitiesIds: [],
                        contextType: RdxContextType.RDX_TC_PROJECT,
                        singleSelection: true,
                        entityName: translate.instant('seemore.attach.requirement_dialog_target'),
                        entityToLink: 'Requirement',
                        displayLinkTypes: false
                    }
                })
                .afterClosed()
        ),
        map((result) => (result ? toRequirementAttachments(result) : []))
    );
}
